export const BLOCKED_TRANSACTION_UUID = '69e28fa8-e1d4-4f58-b2ab-b58462734305';

export const getTransactionUuid = value => {
  if (!value) {
    return null;
  }

  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'object') {
    return value?.uuid || value?.id?.uuid || value?.id || null;
  }

  return null;
};

export const isBlockedTransactionId = value => {
  const transactionUuid = getTransactionUuid(value);
  return transactionUuid === BLOCKED_TRANSACTION_UUID;
};

export const isVisibleTransaction = transaction => !isBlockedTransactionId(transaction);

export const filterVisibleTransactions = transactions => {
  return Array.isArray(transactions) ? transactions.filter(isVisibleTransaction) : [];
};

export const sanitizeTransactionQueryResponse = response => {
  const transactions = response?.data?.data;

  if (!Array.isArray(transactions)) {
    return response;
  }

  const visibleTransactions = filterVisibleTransactions(transactions);

  if (visibleTransactions.length === transactions.length) {
    return response;
  }

  return {
    ...response,
    data: {
      ...response.data,
      data: visibleTransactions,
    },
  };
};
